module.exports = __webpack_public_path__ + "img/3A_old.9b68daa0.jpg";